import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import PageContainer from "../core/PageContainer";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import { HashRouter, NavLink, Route } from "react-router-dom";
import Button from "../core/Button";
import GARouteListener from "../utility/GARouteListener";
import TabContentDiv from "../core/TabContentDiv";
import MyAssignments from "../courses/MyAssignments";
import AssignCourses from "../courses/AssignCourses";
import {
  normalizeUserContextData,
  RailsUserContext,
} from "../../libs/user_context";
import Card from "../core/Card";
import ViewAssignments from "../courses/ViewAssignments";

interface IProps {
  userContext: IUserContextData;
  category ?: string;
  categoryId ?: string;
}

interface IState {
  userContext: IUserContextNormalized;
  // for admins/account managers
  selectedOrgId: string;
}

class CourseAssignments extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    userContext: normalizeUserContextData(this.props.userContext),
    // set this by default to the user's org, only admins/account managers can switch
    selectedOrgId: this.props.userContext.organization.data.id,
  };

  setSelectedOrgId = (orgId: string) => this.setState({ selectedOrgId: orgId });

  render() {
    const { userContext, selectedOrgId } = this.state;

    const canAssign =
      userContext.user.isAdmin ||
      userContext.user.isManager ||
      userContext.user.isOwner;

    return (
      <RailsUserContext.Provider value={userContext}>
        <PageContainer>
          <Breadcrumbs
            crumbs={[
              { label: "Courses", route: `/library?category=${this.props.category}&category_id=${this.props.categoryId}` },
              { label: "Assignments" },
            ]}
          />
          <HashRouter hashType={"noslash"}>
            <Card title={"Course Assignments"}>
              <GARouteListener />
              <div>
                {canAssign && (
                  <ul className="nav nav-tabs nav-justified">
                    <li>
                      <NavLink exact to="/">
                        Your Assignments
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/view">View Assignments</NavLink>
                    </li>
                    <li>
                      <NavLink to="/assign">Assign Courses</NavLink>
                    </li>
                  </ul>
                )}
              </div>
              <TabContentDiv>
                <Route
                  exact
                  path={"/"}
                  render={() => <MyAssignments userContext={userContext} />}
                />
                <Route
                  exact
                  path={"/view"}
                  render={() => (
                    <ViewAssignments
                      selectedOrgId={selectedOrgId}
                      setSelectedOrgId={this.setSelectedOrgId}
                      userContext={userContext}
                    />
                  )}
                />
                <Route
                  path={"/assign"}
                  render={() => (
                    <AssignCourses
                      selectedOrgId={selectedOrgId}
                      setSelectedOrgId={this.setSelectedOrgId}
                      userContext={userContext}
                    />
                  )}
                />
              </TabContentDiv>
            </Card>
          </HashRouter>
        </PageContainer>
      </RailsUserContext.Provider>
    );
  }
}

export default wrapComponentForErrors(CourseAssignments);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/CourseAssignments.tsx